module.exports = __webpack_public_path__ + "img/INGUSH.0ab27301.png";